import axios from "axios";
import instance from "../../../axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/currencies`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}/v3`;

export function createItem(item) {
  return instance.post(`${BASE_URL}/currency/add`, item);
}
export function getList(queryParams) {
  return instance.post(`${BASE_URL}/currency/list`, queryParams);
}

export function getItemById(id) {
  return instance.get(`${BASE_URL}/currency/get/${id}`);
}
export function updateItem(item, id) {
  return instance.post(`${BASE_URL}/currency/update/${id}`, item);
}

export function updateItemsStatus(item, id) {
  return instance.post(`${BASE_URL}/currency/status/${id}`, item);

}
export function deleteItem(id) {
  return instance.post(`${BASE_URL}/currency/delete/${id}`);
}

export function uploadImage(file) {
  let formData = new FormData();
  formData.append("file", file);
  return instance.post(`${BASE_URL}/image/upload`, formData);
}
